import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { Liberacao } from 'src/app/model/liberacao.model';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';

@Injectable({
  providedIn: 'root'
})
export class LiberacaoService extends FgiBackEndService<Liberacao> {
  getNewEntity(): Liberacao {
    return new Liberacao();
  }
  protected getResourceURL(): string {
     return 'front/liberacoes';
  }

  getLiberacao(idLiberacao?: number, options?: any): Observable<Liberacao> {
      return this.http.get(`${this.BASE_URL}/${idLiberacao}` ).pipe(
        catchError((e) => this.handleError(e))) as Observable<Liberacao>;
    }

}
